import React, { useMemo } from 'react';
import TablaDoc from './TablaDoc';

/**
 * Casos con alerta crítica de compliance, en el formato del panel en Word:
 * Origen | Qué se dijo | Acción de hoy.
 * La acción sale de la corrección instruida para ese tipo de riesgo; si el panel
 * no la trae, cae a la acción general de la sección.
 */
const TablaCompliance = ({ compliance, anexo, t }) => {
  const correccionPorTipo = useMemo(() => {
    const mapa = {};
    (compliance?.tipologia_riesgo ?? []).forEach((x) => {
      mapa[x.tipo] = x.correccion_instruida;
    });
    return mapa;
  }, [compliance]);

  const columnas = [
    {
      label: t('ap_colOrigin'),
      ancho: '23%',
      render: (fila) => {
        const mismo =
          String(fila.consultor ?? '').trim() ===
          String(fila.responsable ?? '').trim();
        return (
          <>
            <strong>
              {t('ap_deal')} {fila.deal_id}
            </strong>
            <span className='ap-doc-sec'>{fila.consultor}</span>
            {!mismo && (
              <span className='ap-doc-sec ap-doc-dijo'>
                {t('ap_saidBy')} {fila.responsable}
              </span>
            )}
            <span className='ap-doc-sec'>
              {fila.servicio} · {fila.fecha}
            </span>
          </>
        );
      },
    },
    {
      label: t('ap_colSaid'),
      ancho: '39%',
      render: (fila) => (
        <>
          <em className='ap-doc-cita'>{fila.cita}</em>
          <span className='ap-doc-sec ap-doc-tipo'>{fila.tipo}</span>
        </>
      ),
    },
    {
      label: t('ap_colAction'),
      ancho: '38%',
      render: (fila) =>
        correccionPorTipo[fila.tipo] ?? compliance?.accion_critico ?? '',
    },
  ];

  return (
    <TablaDoc
      columnas={columnas}
      filas={anexo?.casos ?? []}
      textoVacio={t('ap_noRows')}
    />
  );
};

export default TablaCompliance;
